import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/projects/agency/page.tsx");
